module.exports = __webpack_public_path__ + "images/district_back.1788921444950.png";